export const UpdStates = ["Started", "Executing", "DeletionExecuting"];

export const WaitingStates = ["None", "JobAdded"];

export const StartTimerStates = ["Started", "Executing"];

export const FinishStates = ["Finished", "Error", "Fatal", "Deleted", "Canceled", "JobUnscheduled"];

export const MapFermaStates = new Map([
    ["None", "Ожидание запуска"],
    ["Started", "Запущено выполнение"],
    ["Executing", "Задача выполняется"],
    ["Finished", "Задача завершена"],
    ["Error", "Задача завершена с ошибкой"],
    ["Fatal", "Задача завершена с ошибкой"],
    ["Cancelled", "Задача отменена"],
    ["CancellationRequested", "Запрошена отмена задачи"],
    ["Deleted", "Задача удалена"],
    ["DeletionExecuting", "Запрошено удаление задачи"],
    ["JobAdded", "Задача добавлена"],
    ["JobUnscheduled", "Задача удалена"],
    ["Lost", "Проблемы соединения с сервером"]
]);

export const MapEducationStates = new Map([
    ["NORMAL", "Ок"],
    ["EDUCATION", "УВ"]
]);

// TODO (~)   Можно отфильтровывать Trace и Debug логи в контроллерах, чтобы не отсылать их клиенту (логи можно получить из БД фермы)
export const LogLevelAllowed = ["Information", "Warning", "Error", "Critical"];

export function MapFermaStatus(status) {
    if (MapFermaStates.has(status))
        return MapFermaStates.get(status);
    return status;
}

export function MapEducationStatus(status) {
    if (MapEducationStates.has(status))
        return MapEducationStates.get(status);
    return status;
}